import { Injectable, OnDestroy } from '@angular/core';
import { TabletPresence } from '@repo/models';
import { RealtimeChannel, RealtimePresenceState } from '@supabase/supabase-js';
import { BehaviorSubject, Observable } from 'rxjs';
import { DatabaseService } from './database.service';

@Injectable({
  providedIn: 'root',
})
export class RealtimePresenceService extends DatabaseService<any, any> implements OnDestroy {
  private devicesPresenceState$ = new BehaviorSubject<RealtimePresenceState<TabletPresence>>({});

  ngOnDestroy(): void {
    this.devicesPresenceState$.complete();
  }

  public getDevicesPresenceState(): Observable<RealtimePresenceState<TabletPresence>> {
    return this.devicesPresenceState$.asObservable();
  }

  public subscribeForDevicesOnlineStatusRoom() {
    const dbClient = this.getDatabaseClient();
    const presenceRoom = dbClient.channel('companion_app_presence_room', {
      config: {
        presence: {
          enabled: true,
        },
      },
    });
    presenceRoom
      .on('presence', { event: 'sync' }, () => {
        this.publishPresenceSnapshot(presenceRoom);
      })
      .on('presence', { event: 'join' }, ({ newPresences }) => {
        this.publishPresenceSnapshot(presenceRoom);
        newPresences.forEach(async (presences) => {
          const { error } = await dbClient.rpc('resolve_companion_connection_lost_notification', {
            _device_id: presences['device_id'],
          });
          if (error != null) {
            console.error(error);
          }
        });
      })
      .on('presence', { event: 'leave' }, ({ leftPresences }) => {
        this.publishPresenceSnapshot(presenceRoom);
        leftPresences.forEach(async (presences) => {
          const { error } = await dbClient.rpc('create_companion_connection_lost_notification', {
            _device_id: presences['device_id'],
            _data: {
              deviceId: presences['device_id'],
              tabletId: presences['tablet_id'],
            },
            _timezone_offset_minutes: new Date().getTimezoneOffset() * -1,
          });
          if (error != null) {
            console.error(error);
          }
        });
      })
      .subscribe();
  }

  private publishPresenceSnapshot(presenceRoom: RealtimeChannel): void {
    const raw = presenceRoom.presenceState<TabletPresence>();
    this.devicesPresenceState$.next(structuredClone(raw));
  }

  public override getEntities(): Promise<any[]> {
    throw new Error('Method not implemented.');
  }
  public override getRequest(entity: any) {
    throw new Error('Method not implemented.');
  }
  public override createEntity(entity: any): Promise<any> {
    throw new Error('Method not implemented.');
  }
  public override updateEntity(uuid: string, entity: any): Promise<any> {
    throw new Error('Method not implemented.');
  }
  public override deleteEntity(uuid: string): Promise<boolean> {
    throw new Error('Method not implemented.');
  }
}
